import {  selectorFamily } from "recoil";
import axios from "axios";

export const authorizationQuery = selectorFamily({
  key: 'authorizationQuery',
  get: customer => async () => {
    const params = new URLSearchParams();
    params.append('customer', customer);
    const auth = await axios.post("./cgi/authorization.cgi", params).then(res => {
      return res.data;
    }).catch((error) => {
      console.error('authorization failed.');
      throw error;
    });
    return auth;
  }
});